import type { BusinessError } from '@app/models/api/enums/BusinessError';
import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

type panelName = 'login' | 'register' | 'forgotPassword';
type SignInUpModalStoreEditableOptions = {
	panel?: panelName;
	info?: { firstName: string; lastName: string; email: string };
	isOpenFromRefreshToken?: boolean;
	isOpenFromProtectedRoute?: boolean;
	privateOperationCode?: string;
	errorCode?: BusinessError | null;
};

type SignInUpModalStore = {
	open: (options?: SignInUpModalStoreEditableOptions) => void;
	close: () => void;
	switchPanel: (panelName: panelName, errorCode: BusinessError) => void;
};

type SignInUpModalOptions = {
	isOpen: boolean;
} & SignInUpModalStoreEditableOptions;

const store = (): SignInUpModalStore & Writable<SignInUpModalOptions> => {
	const store = writable<SignInUpModalOptions>({ isOpen: false });

	const open = (options?: SignInUpModalStoreEditableOptions) => {
		store.update(() => ({ isOpen: true, ...options }));
	};

	const close = () => {
		store.update(() => ({ isOpen: false }));
	};

	const switchPanel = (panelName: panelName, errorCode: BusinessError | null) => {
		store.update((current) => ({
			...current,
			panel: panelName ?? 'login',
			errorCode: errorCode ?? null
		}));
	};

	return {
		...store,
		open,
		close,
		switchPanel
	};
};

export const signInUpModalStore: SignInUpModalStore & Writable<SignInUpModalOptions> = store();
